(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wubs-ai-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-wubs-ai-chat]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const launcher = root.querySelector('[data-wubs-ai-chat-launcher]');
    const launcherLabel = root.querySelector('[data-wubs-ai-chat-launcher-label]');
    const panel = root.querySelector('[data-wubs-ai-chat-panel]');
    const close = root.querySelector('[data-wubs-ai-chat-close]');
    const title = root.querySelector('[data-wubs-ai-chat-title]');
    const privacy = root.querySelector('[data-wubs-ai-chat-privacy]');
    const log = root.querySelector('[data-wubs-ai-chat-log]');
    const suggestions = root.querySelector('[data-wubs-ai-chat-suggestions]');
    const welcome = root.querySelector('[data-wubs-ai-chat-welcome]');
    const startQuestion = root.querySelector('[data-wubs-ai-chat-start-question]');
    const form = root.querySelector('[data-wubs-ai-chat-form]');
    const input = root.querySelector('[data-wubs-ai-chat-input]');
    const inputLabel = root.querySelector('[data-wubs-ai-chat-input-label]');
    const send = root.querySelector('[data-wubs-ai-chat-send]');
    const disclaimer = root.querySelector('[data-wubs-ai-chat-disclaimer]');
    const portalRoot = document.querySelector('[data-wubs-health-portal]');
    const mode = portalRoot ? 'portal' : 'public';
    root.dataset.mode = mode;
    const copy = (key) => String(root.dataset[key] || '');
    const modeCopy = (suffix) => copy(`${mode}${suffix}`);
    let conversationId = '';
    let busy = false;
    let conversationStarted = false;
    let closeTimer = 0;
    let closeTransitionHandler = null;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const appendThinkingDots = (message) => {
      const dots = document.createElement('span');
      dots.className = 'wubs-health-ai-chat-inline__thinking-dots';
      dots.setAttribute('aria-hidden', 'true');
      for (let index = 0; index < 3; index += 1) {
        const dot = document.createElement('span');
        dot.className = 'wubs-health-ai-chat-inline__thinking-dot';
        dots.append(dot);
      }
      message.append(dots);
    };

    const appendMessage = (text, role, options = {}) => {
      log.hidden = false;
      const message = document.createElement('div');
      message.className = `wubs-ai-chat__message wubs-ai-chat__message--${role}`;
      if (options.emergency) message.classList.add('wubs-ai-chat__message--emergency');
      if (options.loading) message.classList.add('wubs-ai-chat__message--loading');
      message.textContent = options.loading
        ? String(text || '').replace(/[.…\s]+$/u, '')
        : String(text || '');
      if (options.loading) appendThinkingDots(message);
      log.append(message);
      log.scrollTop = log.scrollHeight;
      return message;
    };

    const appendRevealedMessage = async (text, role, options = {}) => {
      const value = String(text || '');
      if (reducedMotion || role !== 'assistant' || options.emergency || value.length < 2) {
        return appendMessage(value, role, options);
      }
      const message = appendMessage('', role, options);
      const visibleText = document.createElement('span');
      visibleText.setAttribute('aria-hidden', 'true');
      message.classList.add('is-revealing');
      message.setAttribute('aria-label', value);
      message.append(visibleText);
      const step = Math.max(2, Math.ceil(value.length / 72));
      await new Promise((resolve) => {
        let position = 0;
        const reveal = () => {
          position = Math.min(value.length, position + step);
          visibleText.textContent = value.slice(0, position);
          log.scrollTop = log.scrollHeight;
          if (position >= value.length) {
            resolve();
            return;
          }
          window.setTimeout(reveal, 12);
        };
        reveal();
      });
      message.classList.remove('is-revealing');
      message.removeAttribute('aria-label');
      message.textContent = value;
      return message;
    };

    const safeSourceUrl = (value) => {
      try {
        const url = new URL(String(value || ''), window.location.origin);
        if (!['http:', 'https:'].includes(url.protocol)) return null;
        return url;
      } catch (_) {
        return null;
      }
    };

    const formatProductPrice = (source) => {
      const direct = source.priceLabel || source.price_label || source.formattedPrice || source.formatted_price;
      if (direct) return String(direct);
      const rawPrice = source.price?.amount ?? source.price;
      const currency = source.price?.currencyCode || source.price?.currency_code || source.currencyCode || source.currency;
      const amount = Number(rawPrice);
      if (Number.isFinite(amount) && currency) {
        try {
          return new Intl.NumberFormat(root.dataset.locale || undefined, { style: 'currency', currency: String(currency) }).format(amount);
        } catch (_) {
          return `${amount} ${currency}`;
        }
      }
      return typeof rawPrice === 'string' ? rawPrice : '';
    };

    const appendSources = (items) => {
      const seenUrls = new Set();
      const valid = (Array.isArray(items) ? items : []).slice(0, 8).flatMap((item) => {
        const source = typeof item === 'string' ? { label: item, url: '' } : item || {};
        const url = safeSourceUrl(source.url || source.product_url || (source.handle ? `/products/${source.handle}` : ''));
        if (!url || seenUrls.has(url.href)) return [];
        seenUrls.add(url.href);
        const rawImage = source.imageUrl || source.image_url || source.image?.url || source.image?.src || source.featuredImage?.url || source.featured_image?.url;
        const imageUrl = rawImage ? safeSourceUrl(rawImage) : null;
        const price = formatProductPrice(source);
        const isProduct = source.kind === 'product' || source.type === 'product' || source.product === true || Boolean(imageUrl && price) || /\/products\//.test(url.pathname);
        return [{ label: String(source.title || source.label || url.hostname), url, imageUrl, price, isProduct, raw: source }];
      });
      if (!valid.length) return;
      const products = valid.filter((source) => source.isProduct);
      const references = valid.filter((source) => !source.isProduct);
      if (products.length) {
        const cards = document.createElement('div');
        cards.className = 'wubs-ai-chat__product-cards';
        let followCards = true;
        let pendingCards = 0;
        const pauseFollow = () => { followCards = false; };
        const scrollToCards = () => { if (followCards && root.dataset.open === 'true') log.scrollTop = log.scrollHeight; };
        const finishCard = () => {
          if (--pendingCards > 0) return;
          log.removeEventListener('wheel', pauseFollow);
          log.removeEventListener('touchstart', pauseFollow);
        };
        log.addEventListener('wheel', pauseFollow, {passive: true});
        log.addEventListener('touchstart', pauseFollow, {passive: true});
        products.forEach((source) => {
          const card = window.WubsAIProducts?.create({...source.raw, url: source.url.href, label: source.label}, {onReady: scrollToCards, onSettled: finishCard});
          if (card) { pendingCards++; cards.append(card); }
        });
        if (cards.children.length) { log.append(cards); scrollToCards(); }
        else { pendingCards = 1; finishCard(); }
      }
      if (!references.length) return;
      const list = document.createElement('div');
      list.className = 'wubs-ai-chat__sources';
      references.forEach((source) => {
        const link = document.createElement('a');
        link.className = 'wubs-ai-chat__source';
        link.href = source.url.href;
        link.textContent = source.label;
        if (source.url.origin !== window.location.origin) {
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        }
        list.append(link);
      });
      log.append(list);
    };

    const renderSuggestions = (items) => {
      suggestions.replaceChildren();
      const values = conversationStarted ? [] : (Array.isArray(items) ? items : []).filter(Boolean).slice(0, 3);
      suggestions.hidden = values.length === 0;
      values.forEach((text) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'wubs-ai-chat__suggestion';
        button.textContent = String(text);
        button.addEventListener('click', () => {
          input.value = String(text);
          input.dispatchEvent(new Event('input', {bubbles: true}));
          input.focus();
        });
        suggestions.append(button);
      });
    };

    const setBusy = (value) => {
      busy = value;
      input.disabled = value;
      send.disabled = value;
      form.setAttribute('aria-busy', value ? 'true' : 'false');
    };

    const openPanel = () => {
      if (closeTransitionHandler) {
        panel.removeEventListener('transitionend', closeTransitionHandler);
        closeTransitionHandler = null;
      }
      window.clearTimeout(closeTimer);
      root.dataset.launcherState = launcher.getBoundingClientRect().width > 90 ? 'expanded' : 'compact';
      panel.hidden = false;
      panel.classList.remove('is-visible');
      root.dataset.open = 'true';
      launcher.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => {
        panel.classList.add('is-visible');
        input.focus();
      });
    };

    const finishClosePanel = () => {
      if (closeTransitionHandler) {
        panel.removeEventListener('transitionend', closeTransitionHandler);
        closeTransitionHandler = null;
      }
      window.clearTimeout(closeTimer);
      panel.hidden = true;
      root.dataset.open = 'false';
      delete root.dataset.launcherState;
      launcher.focus();
    };

    const closePanel = () => {
      if (panel.hidden || root.dataset.open === 'closing') return;
      panel.classList.remove('is-visible');
      root.dataset.open = 'closing';
      launcher.setAttribute('aria-expanded', 'false');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finishClosePanel();
        return;
      }
      closeTransitionHandler = (event) => {
        if (event.target === panel && event.propertyName === 'transform') finishClosePanel();
      };
      panel.addEventListener('transitionend', closeTransitionHandler);
      closeTimer = window.setTimeout(finishClosePanel, 320);
    };

    const publicRequest = async (message, signal) => {
      const response = await fetch(root.dataset.publicEndpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          message,
          conversation_id: conversationId || undefined,
          shop: root.dataset.shop,
          locale: root.dataset.locale,
          country: root.dataset.country,
          host: window.location.host,
          page: {
            type: root.dataset.pageType,
            path: window.location.pathname,
            title: document.title,
          },
        }),
        signal,
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = new Error(response.status === 429 ? copy('rateError') : copy('genericError'));
        error.status = response.status;
        throw error;
      }
      return payload;
    };

    const portalRequest = async (message, requestConversationId = '', surface = '') => {
      const registeredBridge = portalRoot?.id
        ? window.__wubsHealthPortalAssistantBridges?.[portalRoot.id]
        : null;
      const assistantRequest = typeof portalRoot?.wubsHealthAssistantRequest === 'function'
        ? portalRoot.wubsHealthAssistantRequest
        : registeredBridge;
      if (typeof assistantRequest !== 'function') {
        const error = new Error('PORTAL_NOT_CONNECTED');
        error.code = 'PORTAL_NOT_CONNECTED';
        throw error;
      }
      return assistantRequest({
        message,
        conversationId: requestConversationId || undefined,
        locale: root.dataset.locale,
        surface: surface || undefined,
      });
    };

    title.textContent = modeCopy('Title');
    privacy.textContent = modeCopy('Privacy');
    privacy.hidden = !privacy.textContent.trim();
    input.placeholder = modeCopy('Placeholder');
    inputLabel.textContent = modeCopy('Placeholder');
    disclaimer.textContent = copy('disclaimer');
    launcherLabel.textContent = copy('launcher');
    startQuestion.textContent = copy('startQuestion');
    startQuestion.hidden = mode !== 'public';
    log.hidden = mode === 'public';
    if (mode === 'portal') appendMessage(modeCopy('Intro'), 'assistant');
    renderSuggestions([modeCopy('SuggestionOne'), modeCopy('SuggestionTwo')]);

    launcher.addEventListener('click', () => {
      if (panel.hidden) openPanel();
      else closePanel();
    });
    close.addEventListener('click', closePanel);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) closePanel();
    });

    const resizeInput = () => {
      input.style.height = 'auto';
      input.style.height = `${Math.min(120, Math.max(48, input.scrollHeight))}px`;
    };

    input.addEventListener('input', () => {
      input.setCustomValidity('');
      resizeInput();
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        form.requestSubmit();
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy) return;
      const message = input.value.trim();
      if (message.length < 2) {
        input.setCustomValidity(copy('emptyError'));
        input.reportValidity();
        return;
      }
      input.setCustomValidity('');
      conversationStarted = true;
      welcome.hidden = true;
      appendMessage(message, 'user');
      input.value = '';
      resizeInput();
      renderSuggestions([]);
      setBusy(true);
      const loading = appendMessage(copy('thinking'), 'assistant', { loading: true });
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 30000);
      try {
        const payload = mode === 'portal'
          ? await portalRequest(message, conversationId, 'sticky')
          : await publicRequest(message, controller.signal);
        loading.remove();
        conversationId = String(payload?.conversationId || payload?.conversation_id || conversationId || '');
        const answer = String(payload?.answer || payload?.message || payload?.response || copy('genericError'));
        const emergency = payload?.safety?.level === 'emergency' || payload?.emergency === true;
        await appendRevealedMessage(emergency ? `${copy('emergency')}\n\n${answer}` : answer, 'assistant', { emergency });
        appendSources([
          ...(Array.isArray(payload?.products) ? payload.products : []),
          ...(Array.isArray(payload?.productCards) ? payload.productCards : []),
          ...(Array.isArray(payload?.product_cards) ? payload.product_cards : []),
          ...(Array.isArray(payload?.sources) ? payload.sources : []),
        ]);
      } catch (error) {
        loading.remove();
        const portalUnavailable = error?.code === 'PORTAL_NOT_CONNECTED' || error?.message === 'PORTAL_NOT_CONNECTED';
        const text = portalUnavailable
          ? copy('portalUnavailable')
          : error?.code === 'INVALID_ASSISTANT_MESSAGE'
            ? copy('emptyError')
            : error?.status === 429
              ? copy('rateError')
              : copy('genericError');
        appendMessage(text, 'assistant');
      } finally {
        window.clearTimeout(timeout);
        setBusy(false);
        if (root.dataset.open === 'true') input.focus();
      }
    });

    const inlineRoot = document.querySelector('[data-wubs-health-ai-chat-inline]');
    if (inlineRoot && portalRoot && inlineRoot.dataset.initialized !== 'true') {
      inlineRoot.dataset.initialized = 'true';
      const inlineLog = inlineRoot.querySelector('[data-wubs-inline-log]');
      const inlineSuggestions = inlineRoot.querySelector('[data-wubs-inline-suggestions]');
      const inlineSuggestionWrap = inlineRoot.querySelector('[data-wubs-inline-suggestion-wrap]');
      const inlineForm = inlineRoot.querySelector('[data-wubs-inline-form]');
      const inlineInput = inlineRoot.querySelector('[data-wubs-inline-input]');
      const inlineSend = inlineRoot.querySelector('[data-wubs-inline-send]');
      const inlineTypewriter = inlineRoot.querySelector('[data-wubs-inline-typewriter]');
      const inlineTypewriterText = inlineRoot.querySelector('[data-wubs-inline-typewriter-text]');
      const inlineCopy = (key) => String(inlineRoot.dataset[key] || '');
      const initialSuggestions = [...inlineRoot.querySelectorAll('[data-wubs-inline-prompt]')]
        .map((button) => String(button.dataset.wubsInlinePrompt || button.textContent || '').trim())
        .filter(Boolean);
      let inlineConversationId = '';
      let inlineBusy = false;
      let inlineTypewriterTimer = 0;
      let inlineTypewriterIndex = 0;
      let inlineTypewriterPosition = 0;
      let inlineTypewriterDeleting = false;
      let inlineConversationStarted = false;
      const inlinePlaceholder = String(inlineInput.getAttribute('placeholder') || '');
      const inlineReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const appendInlineMessage = (text, role, options = {}) => {
        inlineLog.hidden = false;
        const message = document.createElement('div');
        message.className = `wubs-ai-chat__message wubs-ai-chat__message--${role}`;
        if (options.emergency) message.classList.add('wubs-ai-chat__message--emergency');
        if (options.loading) message.classList.add('wubs-ai-chat__message--loading');
        message.textContent = options.loading
          ? String(text || '').replace(/[.…\s]+$/u, '')
          : String(text || '');
        if (options.loading) {
          const dots = document.createElement('span');
          dots.className = 'wubs-health-ai-chat-inline__thinking-dots';
          dots.setAttribute('aria-hidden', 'true');
          for (let index = 0; index < 3; index += 1) {
            const dot = document.createElement('span');
            dot.className = 'wubs-health-ai-chat-inline__thinking-dot';
            dots.append(dot);
          }
          message.append(dots);
        }
        inlineLog.append(message);
        inlineLog.scrollTop = inlineLog.scrollHeight;
        return message;
      };

      const appendInlineRevealedMessage = async (text, role, options = {}) => {
        const value = String(text || '');
        if (inlineReducedMotion || role !== 'assistant' || options.emergency || value.length < 2) {
          return appendInlineMessage(value, role, options);
        }
        const message = appendInlineMessage('', role, options);
        const visibleText = document.createElement('span');
        visibleText.setAttribute('aria-hidden', 'true');
        message.classList.add('is-revealing');
        message.setAttribute('aria-label', value);
        message.append(visibleText);
        const step = Math.max(2, Math.ceil(value.length / 72));
        await new Promise((resolve) => {
          let position = 0;
          const reveal = () => {
            position = Math.min(value.length, position + step);
            visibleText.textContent = value.slice(0, position);
            inlineLog.scrollTop = inlineLog.scrollHeight;
            if (position >= value.length) {
              resolve();
              return;
            }
            window.setTimeout(reveal, 12);
          };
          reveal();
        });
        message.classList.remove('is-revealing');
        message.removeAttribute('aria-label');
        message.textContent = value;
        return message;
      };

      const renderInlineSuggestions = (items) => {
        inlineSuggestions.replaceChildren();
        const values = inlineConversationStarted ? [] : (Array.isArray(items) ? items : []).filter(Boolean).slice(0, 4);
        inlineSuggestionWrap.hidden = values.length === 0;
        values.forEach((text) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'wubs-health-ai-chat-inline__suggestion';
          button.textContent = String(text);
          button.addEventListener('click', () => {
            inlineInput.value = String(text);
            hideInlineTypewriter(false);
            inlineInput.focus();
          });
          inlineSuggestions.append(button);
        });
      };

      const stopInlineTypewriter = () => {
        if (!inlineTypewriterTimer) return;
        window.clearTimeout(inlineTypewriterTimer);
        inlineTypewriterTimer = 0;
      };

      const hideInlineTypewriter = (useFallbackPlaceholder) => {
        stopInlineTypewriter();
        if (inlineTypewriter) inlineTypewriter.hidden = true;
        inlineInput.setAttribute('placeholder', useFallbackPlaceholder && !inlineConversationStarted ? inlinePlaceholder : '');
      };

      const runInlineTypewriter = () => {
        if (inlineConversationStarted) {
          hideInlineTypewriter(false);
          return;
        }
        if (!inlineTypewriter || !inlineTypewriterText || inlineReducedMotion || !inlineRoot.isConnected || !initialSuggestions.length) {
          hideInlineTypewriter(true);
          return;
        }
        if (document.activeElement === inlineInput || inlineInput.value) {
          hideInlineTypewriter(document.activeElement === inlineInput && !inlineInput.value);
          return;
        }
        inlineInput.setAttribute('placeholder', '');
        inlineTypewriter.hidden = false;
        const phrase = initialSuggestions[inlineTypewriterIndex] || inlinePlaceholder;
        inlineTypewriterText.textContent = phrase.slice(0, inlineTypewriterPosition);
        let delay = inlineTypewriterDeleting ? 28 : 48;
        if (!inlineTypewriterDeleting && inlineTypewriterPosition < phrase.length) {
          inlineTypewriterPosition += 1;
        } else if (!inlineTypewriterDeleting) {
          inlineTypewriterDeleting = true;
          delay = 3000;
        } else if (inlineTypewriterPosition > 0) {
          inlineTypewriterPosition -= 1;
        } else {
          inlineTypewriterDeleting = false;
          inlineTypewriterIndex = (inlineTypewriterIndex + 1) % initialSuggestions.length;
          delay = 450;
        }
        inlineTypewriterTimer = window.setTimeout(runInlineTypewriter, delay);
      };

      const setInlineBusy = (value) => {
        inlineBusy = value;
        inlineSend.disabled = value;
        inlineForm.setAttribute('aria-busy', value ? 'true' : 'false');
      };

      inlineSuggestionWrap.hidden = true;
      if (inlineReducedMotion) {
        hideInlineTypewriter(true);
      } else {
        inlineInput.setAttribute('placeholder', '');
        runInlineTypewriter();
      }

      inlineInput.addEventListener('focus', () => {
        hideInlineTypewriter(!inlineConversationStarted && !inlineInput.value);
      });

      inlineInput.addEventListener('input', () => {
        hideInlineTypewriter(!inlineConversationStarted && !inlineInput.value);
      });

      inlineInput.addEventListener('blur', () => {
        if (inlineConversationStarted) {
          hideInlineTypewriter(false);
          return;
        }
        if (inlineInput.value || inlineReducedMotion) return;
        inlineInput.setAttribute('placeholder', '');
        inlineTypewriterPosition = 0;
        inlineTypewriterDeleting = false;
        inlineTypewriterTimer = window.setTimeout(runInlineTypewriter, 350);
      });

      inlineInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          inlineForm.requestSubmit();
        }
      });

      inlineInput.addEventListener('input', () => inlineInput.setCustomValidity(''));

      inlineForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (inlineBusy) return;
        const message = inlineInput.value.trim();
        if (message.length < 2) {
          inlineInput.setCustomValidity(inlineCopy('emptyError'));
          inlineInput.reportValidity();
          return;
        }
        inlineInput.setCustomValidity('');
        inlineConversationStarted = true;
        inlineRoot.classList.add('is-started');
        appendInlineMessage(message, 'user');
        inlineInput.value = '';
        hideInlineTypewriter(false);
        renderInlineSuggestions([]);
        setInlineBusy(true);
        const loading = appendInlineMessage(inlineCopy('thinking'), 'assistant', { loading: true });
        let timeout = 0;
        try {
          const timeoutRequest = new Promise((_, reject) => {
            timeout = window.setTimeout(() => {
              const error = new Error('REQUEST_TIMEOUT');
              error.code = 'REQUEST_TIMEOUT';
              reject(error);
            }, 30000);
          });
          const payload = await Promise.race([
            portalRequest(message, inlineConversationId),
            timeoutRequest,
          ]);
          loading.remove();
          inlineConversationId = String(payload?.conversationId || payload?.conversation_id || inlineConversationId || '');
          const answer = String(payload?.answer || payload?.message || payload?.response || inlineCopy('genericError'));
          const emergency = payload?.safety?.level === 'emergency' || payload?.emergency === true;
          await appendInlineRevealedMessage(
            emergency ? `${inlineCopy('emergency')}\n\n${answer}` : answer,
            'assistant',
            { emergency },
          );
        } catch (error) {
          loading.remove();
          const portalUnavailable = error?.code === 'PORTAL_NOT_CONNECTED' || error?.message === 'PORTAL_NOT_CONNECTED';
          const text = portalUnavailable
            ? inlineCopy('portalUnavailable')
            : error?.status === 429
              ? inlineCopy('rateError')
              : inlineCopy('genericError');
          appendInlineMessage(text, 'assistant');
        } finally {
          window.clearTimeout(timeout);
          setInlineBusy(false);
          inlineInput.focus();
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wubs-sti-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initBundleOffer = (bundle) => {
      if (bundle.dataset.initialized === 'true') return;
      bundle.dataset.initialized = 'true';

      const button = bundle.querySelector('[data-wubs-bundle-add]');
      const status = bundle.querySelector('[data-wubs-bundle-status]');
      const bundleVariantId = Number(bundle.dataset.bundleVariantId);
      const isAvailable = bundle.dataset.available === 'true';
      const errorText = bundle.dataset.error || '';
      const rootUrl = (bundle.dataset.rootUrl || '/').replace(/\/$/, '');

      if (!button) return;

      const buildUrl = (path) => `${rootUrl}${path.startsWith('/') ? path : `/${path}`}`;

      const openCart = () => {
        try {
          if (window.WubsCartDrawer && typeof window.WubsCartDrawer.open === 'function') {
            window.WubsCartDrawer.open();
            return true;
          }
        } catch (error) {}

        try {
          if (window.wubsCartDrawerOpen) {
            const keys = Object.keys(window.wubsCartDrawerOpen);
            for (const key of keys) {
              if (typeof window.wubsCartDrawerOpen[key] === 'function') {
                window.wubsCartDrawerOpen[key]();
                return true;
              }
            }
          }
        } catch (error) {}

        try {
          document.dispatchEvent(new CustomEvent('wubs:cart-open', { detail: { mode: 'drawer' } }));
          return true;
        } catch (error) {}

        return false;
      };

      button.addEventListener('click', async () => {
        if (!isAvailable || !bundleVariantId || button.getAttribute('aria-busy') === 'true') return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (status) status.textContent = '';

        try {
          const response = await fetch(buildUrl('/cart/add.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: bundleVariantId, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart add failed');
          await response.json();
          if (!openCart()) window.location.href = buildUrl('/cart');
        } catch (error) {
          if (status) status.textContent = errorText;
        } finally {
          button.removeAttribute('aria-busy');
          button.disabled = !isAvailable;
        }
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-wubs-bundle-offer]').forEach(initBundleOffer);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
